<!--
 * @Author: Scarlett Xiao
 * @Date: 2022-01-04 15:05:32
 * @LastEditors: lishiqiao
 * @LastEditTime: 2022-01-14 10:55:21
-->
<template>
  <!-- 养成销售概览 -->
  <div class="content-wrap">
    <div class="page-list">
      <div class="page-type-switch">
        <div
          :class="pageType === 'volume' ? 'type-activite' : ''"
          @click="pageType = 'volume'"
        >
          销售量
        </div>
        <div
          :class="pageType === 'customer' ? 'type-activite' : ''"
          @click="pageType = 'customer'"
        >
          客户应收
        </div>
      </div>
      <!-- 销售量 -->
      <VolumePage v-if="pageType === 'volume'" />
      <!-- 客户应收 -->
      <CustomerPage v-if="pageType === 'customer'" />
    </div>
  </div>
</template>

<script>
import VolumePage from "./yc-sales-volume.vue";
import CustomerPage from "./yc-sales-customer/yc-sales-customer.vue";
export default {
  name: "yc-sales",
  data() {
    return {
      pageType: "volume",
    };
  },
  computed: {},
  methods: {},
  components: {
    VolumePage,
    CustomerPage,
  },
  beforeMount() {
    // 模板编译/挂载之前
  },
  mounted() {
    // 模板编译/挂载之后
  },
  created() {},
  beforeUpdate() {
    // 组件更新之前
  },
  updated() {
    // 组件更新之后
  },
  beforeDestroy() {
    // 组件销毁前调用
    // Tips：你确认删除XX吗？
  },
  destroyed() {
    // 组件销毁后调用
    // Tips：当前组件已被删除，清空相关内容
  },
  // 数据监听
  watch: {
    // keyName: {
    // 注意：当观察的数据为对象或数组时，curVal和oldVal是相等的，因为这两个形参指向的是同一个数据对象
    // deep: true,
    //handler (curVal, oldVal) {
    // console.log(curVal, oldVal)
    //}
    // }
  },
};
</script>

<style lang="less" scoped>
</style>